// extracted by mini-css-extract-plugin
export default {"multiplechoicebutton":"multiplechoice_multiplechoicebutton__Wknoy","wrong":"multiplechoice_wrong__PJi-B","shake":"multiplechoice_shake__GB6wZ"};